import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image", "counter", "caption", "thumb"]
  static values = {
    photos: Array,
    index: { type: Number, default: 0 }
  }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const index = Number(event.currentTarget.dataset.variantPhotoViewerIndex || 0)
    this.indexValue = Number.isNaN(index) ? 0 : index
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.boundKeydown)
    this.render()
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.boundKeydown)
  }

  previous(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (!this.hasPhotos()) return

    this.indexValue = (this.indexValue - 1 + this.photosValue.length) % this.photosValue.length
    this.render()
  }

  next(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (!this.hasPhotos()) return

    this.indexValue = (this.indexValue + 1) % this.photosValue.length
    this.render()
  }

  show(event) {
    event.preventDefault()
    event.stopPropagation()

    const index = Number(event.currentTarget.dataset.variantPhotoViewerIndex || 0)
    this.indexValue = Number.isNaN(index) ? 0 : index
    this.render()
  }

  handleBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
    } else if (event.key === "ArrowLeft") {
      this.previous(event)
    } else if (event.key === "ArrowRight") {
      this.next(event)
    }
  }

  render() {
    if (!this.hasPhotos()) return

    const photo = this.photosValue[this.indexValue]
    this.imageTarget.src = photo.preview_url
    this.imageTarget.alt = photo.label || photo.filename || ""
    this.counterTarget.textContent = `${this.indexValue + 1} / ${this.photosValue.length}`
    this.captionTarget.textContent = photo.filename || photo.label || ""

    this.thumbTargets.forEach((thumb, index) => {
      thumb.classList.toggle("ring-2", index === this.indexValue)
      thumb.classList.toggle("ring-teal-500", index === this.indexValue)
      thumb.classList.toggle("opacity-60", index !== this.indexValue)
    })
  }

  hasPhotos() {
    return this.photosValue && this.photosValue.length > 0
  }
}
